export const TOP_MUSIC_TRACK = {
  title: "知足",
  source: "/audio/zhizu.mp4",
} as const;

export const MUSIC_DISMISSED_SESSION_KEY = "wmlsti:music-dismissed";
